import React from 'react';
import {
  Container,
  ModalHeader,
  Title,
  ModalBody,
  ModalContent,
  ItemCard,
  ItemIconContainer,
  ItemIcon,
  ItemName,
  ItensList,
  Item,
} from './styles';
import {useNavigation} from '@react-navigation/native';

interface Props {
  showModal: boolean;
  onDismiss: () => void;
}

export function SelectCardTypeModal({showModal, onDismiss}: Props) {
  const navigation = useNavigation();

  const handleNavigation = (voucher: boolean) => {
    onDismiss();
    navigation.navigate('AddCreditCard', {voucher: voucher});
  };
  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ModalHeader>
          <Title>Escolha um meio de pagamento</Title>
        </ModalHeader>
        <ModalBody>
          <ItensList>
            <Item>
              <ItemCard
                activeOpacity={1}
                onPress={() => handleNavigation(false)}>
                <ItemIconContainer>
                  <ItemIcon name="credit-card" />
                </ItemIconContainer>
                <ItemName>Cartão de crédito</ItemName>
              </ItemCard>
            </Item>
            <Item>
              <ItemCard
                activeOpacity={1}
                onPress={() => handleNavigation(true)}>
                <ItemIconContainer>
                  <ItemIcon name="vcard-o" />
                </ItemIconContainer>
                <ItemName>Vale (VR, Pluxee)</ItemName>
              </ItemCard>
            </Item>
          </ItensList>
        </ModalBody>
      </ModalContent>
    </Container>
  );
}
